(function () {
  /* Ververst de productverhaal-onderdelen (kerngegevens, omschrijving, specificaties) als je een andere variant kiest. */
  function init() {
    var roots = document.querySelectorAll('[data-sw-story]');
    if (!roots.length) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var v = event && event.data && event.data.variant;
      if (!v || !v.id) return;
      Array.prototype.forEach.call(document.querySelectorAll('[data-sw-story]'), function (root) {
        var url = root.getAttribute('data-product-url') + '?variant=' + v.id + '&section_id=' + root.getAttribute('data-section-id');
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-sw-story]');
            if (fresh) root.innerHTML = fresh.innerHTML;
          })
          .catch(function () {});
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
